import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { SortOptionValues } from '@shared/models/tree-selector.models';
import {EntitySetting} from '../../../models/entity-setting.model';

@Component({
    standalone: false,
    selector: 'lib-app-transaction-country-selector',
  templateUrl: './transaction-country-selector.component.html',
  styleUrls: ['./transaction-country-selector.component.scss']
})
export class TransactionCountrySelectorComponent implements OnInit, OnDestroy {
  @Input('countryList') countryList$: BehaviorSubject<EntitySetting[]> = new BehaviorSubject([]);
  @Input('displayLabel') displayLabel: string;
  @Input('componentDisabled') componentDisabled: boolean;
  @Input('resetSelection') resetSelection$: Subject<any>;
  @Input('selectedItemId') selectedItemId$: Subject<any>;
  @Input('emptyMessage') emptyMessage: string;
  @Output() countryClicked: EventEmitter<{settings: EntitySetting, isPaying: boolean}> = new EventEmitter();
  countryListViewModel: EntitySetting[];
  sectedIndex: number;
  searchText: string;
  Form: FormGroup;
  unSubscribe$ = new Subject<void>();
  sortOptions = [
    {
      title: 'Ascending',
      value: SortOptionValues.ASCENDING
    },
    {
      title: 'Checked',
      value: SortOptionValues.ASCENDINGCHECKED
    }
  ];
  selectedSortOption = SortOptionValues.ASCENDING;
  selectedCountry: EntitySetting;
  constructor() {
  }

  ngOnInit() {
    this.countryListViewModel = [];
    this.Form = new FormGroup({
      search: new FormControl()
    });
    this.subscribeToObservables();
  }

  private subscribeToObservables () {
    this.countryList$.pipe(
      takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.length === 0) {
        return;
      }

      if (this.countryListViewModel && this.countryListViewModel.length > 0) {

        const dataAsArray = data.reduce(function (map, obj) {
          map[obj.entity.id] = obj;
          return map;
        }, {});

        this.countryListViewModel.forEach((part) => {
          part.isChecked = dataAsArray[part.id].isChecked;
        });

        if (this.selectedSortOption === SortOptionValues.ASCENDINGCHECKED) {
          this.countryListViewModel.sort((a, b) => this.alphabeticalSortAsc(a, b)).sort((c, d) => this.alphabeticalCheckedSortDesc(c, d));
        }
      } else {
        [...data].sort((a, b) => this.alphabeticalSortAsc(a, b)).forEach((part, index, theArray) => {
          this.countryListViewModel.push(new EntitySetting({...part, id: part.entity.id}));
        });
      }
    });

    this.resetSelection$.pipe(
      takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.resetPaying && this.displayLabel === 'Paying') {
        this.resetSelection();
      } else if (data.resetReceiving && this.displayLabel === 'Receiving') {
        this.resetSelection();
      }
    });

    this.selectedItemId$.pipe(
      takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.id && this.displayLabel === 'Paying') {
        this.sectedIndex = this.countryListViewModel.map(function (e) { return e.id; }).indexOf(data.id);
      } else if (data.id && this.displayLabel === 'Receiving') {
        this.sectedIndex = this.countryListViewModel.map(function (e) { return e.id; }).indexOf(data.id);
      }
    });
  }

  ngOnDestroy (): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
  private resetSelection () {
    this.sectedIndex = -1;
    this.selectedCountry = null;
  }

  selectCounty(settings: EntitySetting, index: number) {
    if (this.componentDisabled) {
      return;
    }

    this.sectedIndex = index;
    this.selectedCountry = this.countryListViewModel[index];
    const isPaying = this.displayLabel === 'Paying';
    const obj = {settings: settings, isPaying: isPaying};
    this.countryClicked.emit(obj);
  }

  // Sorting events
  onSortOptionChange() {
    if (this.selectedSortOption === SortOptionValues.ASCENDING) {
      this.countryListViewModel.sort((a, b) => this.alphabeticalSortAsc(a, b));
    } else {
      this.countryListViewModel.sort((a, b) => this.alphabeticalSortAsc(a, b)).sort((c, d) => this.alphabeticalCheckedSortDesc(c, d));
    }
    this.sectedIndex = this.countryListViewModel.indexOf(this.selectedCountry);
  }


  alphabeticalSortAsc(a: EntitySetting, b: EntitySetting) {
    if (a.entity.title > b.entity.title) {
      return 1;
    } else if (a.entity.title < b.entity.title) {
      return -1;
    } else {
      return 0;
    }
  }

  alphabeticalCheckedSortDesc(a: EntitySetting, b: EntitySetting) {
    if (a.isChecked) {
      return -1;
    } else {
      return 1;
    }
  }
}
